'use client';
import { jsx } from 'react/jsx-runtime';
import { defineStyle } from '@chakra-ui/styled-system';
import { dataAttr, cx } from '@chakra-ui/utils';
import { useProgressStyles, useProgressContext } from './progress-context.mjs';
import { stripeAnim, progressAnim } from './progress-utils.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const ProgressFilledTrack = forwardRef(
  function ProgressFilledTrack2(props, ref) {
    const { role, style, ...rest } = props;
    const styles = useProgressStyles();
    const api = useProgressContext();
    const shouldAddStripe = !api.isIndeterminate && api.hasStripe;
    const trackStyles = defineStyle({
      "--stripe-animation": `${stripeAnim}`,
      "--progress-animation": `${progressAnim}`,
      ...styles.filledTrack
    });
    return /* @__PURE__ */ jsx(
      chakra.div,
      {
        ref,
        style: { width: `${api.computed.percent}%`, ...style },
        "data-animated": dataAttr(shouldAddStripe && api.isAnimated),
        role: "progressbar",
        "data-indeterminate": dataAttr(api.isIndeterminate),
        "aria-valuemax": api.computed.max,
        "aria-valuemin": api.computed.min,
        "aria-valuenow": api.isIndeterminate ? void 0 : api.computed.value,
        "aria-valuetext": api.computed.valueText,
        ...rest,
        __css: trackStyles,
        className: cx("chakra-progress__filled-track", props.className)
      }
    );
  }
);

export { ProgressFilledTrack };
